import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Form,
  Row,
  Col,
  Spin,
  Typography,
  Card,
  Button,
  message,
  DatePicker,
  Input,
} from 'antd';
import {
  DeleteOutlined,
  SearchOutlined,
  ArrowLeftOutlined,
  SaveOutlined,
  StopOutlined,
} from '@ant-design/icons';
import { onError } from 'utils/handlers';
// import API from 'utils/api';
import CustomTable from 'components/Table';
import NumericInput from 'components/NumericInput';
import FormSubmitCustomControls from 'components/FormSubmitCustomControls';
import Select from 'components/Select';

import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { hasActionPermission, ActionsNames } from 'utils/permission/index';
import { DATE_FORMAT, DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import { InputSearchPro } from 'components/InputSearch';
import BusquedaAvanzadaUsers from 'components/BusquedaAvanzadaCajeros';
import {
  getDepositosBancarios, postDepositoBancario, patchDepositoBancario,
  getDepositoBancario,
} from 'api/recaudacion/depositosBancarios';
import { getBancos } from 'api/configuracion/bancos';
import { getUsuario, getUsuarios } from 'api/usuarios/usuarios';

import toCurrency from 'utils/toCurrency';
import { getTiposDeDepositosBancarios } from 'api/configuracion/tiposDeDepositoBancario';
// import { getTiposDeCuentasBancarias } from 'api/configuracion';
import { getCortes } from 'api/recaudacion/cortes';
import { getCuentasDeBanco } from 'api/configuracion/cuentasDeBancos';
import { capitalize, toMoment } from 'utils/normalizers';

const { Text, Title } = Typography;

// eslint-disable-next-line react/prop-types
const DepositosBancarios = ({ permission }) => {
  const [form] = Form.useForm();
  const [formDeposito] = Form.useForm();
  const { entidad } = useSelector(({ auth }) => auth);
  const exigeCajero = entidad?.exigir_cajero_en_depositos_bancarios;
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [cajero, setCajero] = useState([]);
  const [unidadRecaudadora, setUnidadRecaudadora] = useState([]);
  const [banco, setBanco] = useState([]);
  const [visible, setVisible] = useState(false);
  const [tipoDeDeposito, setTipoDeDeposito] = useState([]);
  // const [tipoDeCuentaBancaria, setTipoDeCuentaBancaria] = useState([]);
  const [hasAllViewPermission, setHasAllViewPermission] = useState(true);
  const [visibleAdvancedSupervisor, setVisibleAdvancedSupervisor] = useState(false);
  const [visibleBusqueda, setVisibleBusqueda] = useState(false);
  const [user, setUser] = useState([]);
  const [cortes, setCortes] = useState([]);
  const [cuentaBancaria, setCuentaBancaria] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    const dataUnidadesDeRecaudacion = await getUnidadesDeRecaudacion();
    const _bancos = await getBancos();
    const _tipoDeDeposito = await getTiposDeDepositosBancarios();
    // const _tiposDeCuentasBancarias = await getTiposDeCuentasBancarias();

    setBanco(_bancos);
    setUnidadRecaudadora(dataUnidadesDeRecaudacion);
    setTipoDeDeposito(_tipoDeDeposito);
    // setTipoDeCuentaBancaria(_tiposDeCuentasBancarias);
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const validatePermission = () => {
      const _hasAllViewPermission = ['unidadderecaudacion', 'usuario']
        .map((m) => hasActionPermission(m, ActionsNames.view))
        .every((e) => e);
      if (!_hasAllViewPermission) {
        message.warn('Hacen falta permisos en los catálogos relacionados a este módulo');
      }
      if (mounted) {
        setHasAllViewPermission(_hasAllViewPermission);
      }
    };
    validatePermission();
    if (mounted) {
      fetchData();
    }
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    formDeposito.resetFields();
    setSelectedRowKeys([]);
    setCajero([]);
    setUser([]);
    setCortes([]);
  };

  const options = [
    {
      label: 'Pendiente',
      value: false,
    },
    {
      label: 'Depositado',
      value: true,
    },
  ];

  const handleSearch = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const params = form.getFieldsValue();
      if (params?.fecha_del_ingreso) {
        params.fecha_del_ingreso_after = params.fecha_del_ingreso[0].format(DATE_FORMAT);
        params.fecha_del_ingreso_before = params.fecha_del_ingreso[1].format(DATE_FORMAT);
        delete params.fecha_del_ingreso;
      }
      if (params?.fecha_del_deposito) {
        params.fecha_del_deposito_after = params.fecha_del_deposito[0].format(DATE_FORMAT);
        params.fecha_del_deposito_before = params.fecha_del_deposito[1].format(DATE_FORMAT);
        delete params.fecha_del_deposito;
      }
      const dataDepositos = await getDepositosBancarios(params);
      setData(dataDepositos);
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onFinishDeposito = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      await formDeposito.validateFields();
      const values = formDeposito.getFieldsValue();
      // eslint-disable-next-line max-len
      const successed = key ? await patchDepositoBancario(key, values) : await postDepositoBancario(values);
      if (successed) {
        if (successed && key) {
          message.success('Deposito Editado Correctamente');
          await handleSearch();
          onCancel();
        }
      }
      setLoading(false);
    } catch (error) {
      onError(error);
    }
  };

  const fillCorte = async (fecha_del_ingreso = null, usuario_cajero = null) => {
    try {
      setLoading(true);

      const apertura = fecha_del_ingreso?.format(DATE_FORMAT);

      if (!(apertura && usuario_cajero)) return;
      const cortesFound = await getCortes({
        apertura_before: apertura,
        apertura_after: apertura,
        usuario_cajero,
      });

      if (!cortesFound) return;

      setCortes(cortesFound);

      if (cortesFound.length === 1) {
        const [corte] = cortesFound;
        formDeposito.setFieldsValue({
          cortes: corte?.id,
          unidad_de_recaudacion: corte?.unidad_de_recaudacion,
        });
      }
      setLoading(false);
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUser = async (id) => {
    setLoading(true);
    if (id) {
      const _user = await getUsuario(id?.id || id);
      if (_user) {
        formDeposito.setFieldsValue({
          usuario_cajero: _user.id,
        });
        const matched = {
          ..._user,
          nombre_completo: `${_user?.first_name} ${_user?.last_name
            || ''} ${_user?.second_last_name || ''}`,
        };
        setUser(matched);
        if (matched) {
          await fillCorte(formDeposito.getFieldValue('fecha_del_ingreso'), matched?.id);
        }
      } else {
        message.info('No se encontró usuario');
      }
    }
    setLoading(false);
  };

  const required = {
    required: true,
    message: 'El campo es requerido',
  };
  const rules = {
    required: [{ required: true }],
    requiredOr: [
      {
        validator: async () => {
          const values = form.getFieldsValue();
          const keys = Object.keys(values);
          const validProps = keys.filter((prop) => values[prop]);
          if (!validProps.length) {
            throw new Error('Debe ingresar al menos un campo');
          }
        },
      },
    ],
    referencia_bancaria: [
      required,
      {
        validator: async () => {
          const { referencia_del_deposito } = formDeposito.getFieldsValue();
          if (referencia_del_deposito.length < 4) {
            throw new Error('La longitud del campo no puede ser menor a 4 caracteres');
          }
        },
      },
    ],
    fecha_del_deposito: [
      required,
      {
        validator: async () => {
          const { fecha_del_deposito, fecha_del_ingreso } = formDeposito.getFieldsValue();
          if (!fecha_del_ingreso.isBefore(fecha_del_deposito)) {
            throw new Error('La fecha de ingreso no puede ser anterior a la fecha de Deposito');
          }
        },
      },
    ],
  };

  const columns = [
    {
      titleText: 'Fecha de Ingreso',
      dataIndex: 'fecha_del_ingreso',
      key: 'fecha_del_ingreso',
      width: 300,
      render: (val) => (val?.format?.(DATE_FRONTEND_FORMAT) || val),
    },

    {
      titleText: 'Fecha del Depósito',
      dataIndex: 'fecha_del_deposito',
      key: 'fecha_del_deposito',
      width: 300,
      render: (val) => (val?.format?.(DATE_FRONTEND_FORMAT) || val),
    },
    {
      titleText: 'Referencia',
      dataIndex: 'referencia_del_deposito',
      key: 'referencia_del_deposito',
      width: 200,
    },
    exigeCajero && {
      titleText: 'Cajero',
      dataIndex: 'usuario_cajero',
      key: 'usuario_cajero',
      width: 150,
      render: (val) => (`${val?.first_name} ${val?.last_name} ${val?.second_last_name || ''} `),
    },
    {
      titleText: 'Importe de Depósito',
      dataIndex: 'importe_del_deposito',
      key: 'importe_del_deposito',
      width: 300,
      render: (val) => toCurrency(val),
    },
    {
      titleText: 'Banco',
      dataIndex: 'bancos',
      key: 'bancos',
      width: 200,
      catalog: {
        cat: banco,
        labelProp: 'nombre',
        use: false,
      },
    },
    exigeCajero && {
      titleText: 'Corte',
      dataIndex: 'cortes',
      key: 'cortes',
      width: 150,
      render: (val) => (val?.apertura ? toMoment(val.apertura)?.format(DATE_FRONTEND_FORMAT) : 'N/A'),
    },
    {
      titleText: 'Unidad Recaudadora',
      dataIndex: 'unidad_de_recaudacion',
      key: 'unidad_de_recaudacion',
      width: 300,
      catalog: {
        cat: unidadRecaudadora,
        labelProp: 'descripcion',
        use: false,
      },
    },

  ];

  const controls = [
    {
      onClick: () => setVisible(false),
      icon: <ArrowLeftOutlined />,
      text: 'Regresar',
    },
    {
      onClick: () => onFinishDeposito(),
      icon: <SaveOutlined />,
      text: 'Guardar',
    },
  ];

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    formDeposito.setFieldsValue(record);
  };

  const filter = async (bancos) => {
    try {
      setLoading(true);
      if (bancos) {
        const _bancos = await getCuentasDeBanco({ banco: bancos });
        setCuentaBancaria(_bancos);
      } else {
        setCuentaBancaria([]);
      }
      setLoading(false);
    } catch (error) {
      onError(error);
    }
  };

  const onClickEdit = async () => {
    const [key] = selectedRowKeys;
    const match = await getDepositoBancario(key);
    if (match?.estados_globales !== 4) {
      await filter(match?.bancos);

      if (match?.usuario_cajero) {
        await fetchUser(match.usuario_cajero);
      }

      if (match) setVisible(true);
    } else {
      message.warn('No se pueden editar Depositós Autorizados');
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const wipe = () => {
    form.resetFields();
    setData([]);
  };
  const searchControls = [
    {
      onClick: () => wipe(),
      icon: <DeleteOutlined />,
      text: 'Limpiar Busqueda',
    },
    {
      onClick: () => handleSearch(),
      icon: <SearchOutlined />,
      text: 'Buscar',
    },
  ];

  const cancel = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = data.find((e) => e.id === key);
    if (match) {
      const canceled = patchDepositoBancario(key, { estados_globales: 5 });
      if (canceled) {
        message.info('Deposito Cancelado correctamente');
        await handleSearch();
      }
    } else {
      message.warn('Este depósito ya fue autorizado anteriormente intente con otro');
    }
    setLoading(false);
  };

  const reset = () => {
    setCajero([]);
    setUser([]);
    setCortes([]);
    form.resetFields(['q']);
    formDeposito.resetFields(['q', 'cortes']);
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const searchCajero = async () => {
    try {
      setLoading(true);
      const { q: email } = form.getFieldsValue();
      const resCajero = await getUsuarios({ email });

      if (resCajero.length) {
        form.setFieldsValue({
          usuario_cajero: resCajero[0].id,
        });
        const _cajero = resCajero.map((e) => ({
          ...e,
          nombre_completo: `${e.first_name} ${e.last_name || ''} ${e.second_last_name || ''}`,
        }));
        setCajero([_cajero[0]]);
      } else {
        message.info('No se encontraron coincidencias');
        setCajero([]);
      }
      setLoading(false);
    } catch (error) {
      onError(error, setLoading);
    }
  };

  const fillFields = (val) => {
    if (val) {
      const clone = [...cuentaBancaria];
      const match = clone.find((i) => i.id === val);
      if (match) {
        formDeposito.setFieldsValue({
          cuenta_contable_de_banco: match?.cuenta_contable || '',
        });
      }
    }
  };
  const searchUsuario = async () => {
    try {
      setLoading(true);

      const { q: email } = formDeposito.getFieldsValue();

      if (!email) {
        message.info('No se encontraron coincidencias');
        setUser([]);
        setCajero([]);
        return;
      }

      const resCajero = await getUsuarios({ email });
      if (!resCajero.length) {
        message.info('Favor de llenar el campo con el email del usuario');
        return;
      }
      formDeposito.setFieldsValue({ usuario_cajero: resCajero[0].id });

      const _cajero = resCajero.map((e) => ({
        ...e,
        nombre_completo: `${e.first_name} ${e.last_name || ''} ${e.second_last_name || ''}`,
      }));
      setUser([_cajero[0]]);
      await fillCorte(formDeposito.getFieldValue('fecha_del_ingreso'), resCajero[0].id);
    } catch (error) {
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible && selectedRowKeys ? (
          <Card
            bordered={false}
            className="form-container"
            title="Depósitos Bancarios"
            extra={(
              <FormSubmitCustomControls
                controls={searchControls}
              />
            )}
          >
            <Form
              layout="vertical"
              form={form}
              scrollToFirstError
              onFinish={() => handleSearch()}
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_del_ingreso"
                    label="Fecha de Ingreso"
                    hasFeedback
                  >
                    <DatePicker.RangePicker
                      placeholder=""
                      format={DATE_FRONTEND_FORMAT}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_del_deposito"
                    label="Fecha del Depósito"
                    hasFeedback
                  >
                    <DatePicker.RangePicker
                      placeholder=""
                      format={DATE_FRONTEND_FORMAT}

                    />
                  </Form.Item>
                </Col>
                {hasAllViewPermission && (
                  <>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="unidad_de_recaudacion"
                        label="Unidad de recaudación"
                        hasFeedback
                      >
                        <Select dataSource={unidadRecaudadora} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="bancos"
                        label="Banco"
                        hasFeedback
                      >
                        <Select dataSource={banco} labelProp="nombre" />
                      </Form.Item>
                    </Col>
                  </>
                )}
                {!!exigeCajero && (
                  <InputSearchPro
                    label="Cajero"
                    tooltip="Búsqueda por Correo del Cajero"
                    name="q"
                    rules={rules.email}
                    onClickAdvanced={() => setVisibleAdvancedSupervisor(true)}
                    onPressEnter={() => searchCajero()}
                    breakPoints={{
                      md: 8,
                    }}
                    resultProps={{
                      name: 'usuario_cajero',
                      label: 'Cajero',
                      dataSource: cajero,
                      labelProp: 'nombre_completo',
                      // onChange: () => fillCorte(),
                      onClear: () => reset(),
                      breakPoints: {
                        md: 8,
                      },
                    }}
                  />
                )}

              </Row>
            </Form>
            <Col span={24}>
              <Title level={4}>
                <Text>
                  Depósitos encontrados
                </Text>
              </Title>
            </Col>
            <CustomTable
              cols={columns}
              data={data}
              rowSelection={rowSelection}
              mobileColIndex={0}
              rowKey="id"
              handleOnRowClick={handleOnRowClick}
              allowEdit
              allowAdd
              controls={{
                onClickEdit,
                onClickAdd,
              }}
              permission={permission}
              hasAllViewPermission={hasAllViewPermission}
              customActions={[
                {
                  onClick: async () => cancel(),
                  icon: <StopOutlined />,
                  text: 'Cancelar',
                },
              ]}
            />
          </Card>
        ) : (
          <Col span={24}>
            <Card
              bordered={false}
              className="form-container"
              title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Depósito`}
              extra={(
                <FormSubmitCustomControls
                  controls={controls}
                />
              )}
            >
              <Col span={24}>
                <Form
                  layout="vertical"
                  form={formDeposito}
                  onFinish={() => onFinishDeposito()}
                  scrollToFirstError
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="fecha_del_ingreso"
                        label="Fecha de Ingreso"
                        hasFeedback
                        rules={rules.required}
                      >
                        <DatePicker
                          placeholder=""
                          format={DATE_FRONTEND_FORMAT}
                          onChange={(val) => fillCorte(val, null)}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="fecha_del_deposito"
                        label="Fecha del Depósito"
                        hasFeedback
                        rules={rules.required}
                      >
                        <DatePicker
                          placeholder=""
                          format={DATE_FRONTEND_FORMAT}
                          disabledDate={(date) => date.isAfter(new Date())}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_deposito_pendiente"
                        label="Estatus"
                        hasFeedback
                      >
                        <Select
                          dataSource={options}
                          labelProp="label"
                          valueProp="value"
                        />
                      </Form.Item>
                    </Col>
                    {!!exigeCajero && (
                      <>
                        <InputSearchPro
                          label="Cajero"
                          tooltip="Búsqueda por Correo del Cajero"
                          name="q"
                          rules={rules.email}
                          onClickAdvanced={() => setVisibleBusqueda(true)}
                          onPressEnter={() => searchUsuario()}
                          breakPoints={{
                            md: 8,
                          }}
                          inputProps={{
                            onPressEnter: () => searchUsuario(),
                          }}
                          resultProps={{
                            name: 'usuario_cajero',
                            label: 'Cajero',
                            dataSource: user,
                            labelProp: 'nombre_completo',
                            onClear: () => reset(),
                            onChange: (val) => fillCorte(formDeposito.getFieldValue('fecha_del_ingreso'), val),
                            breakPoints: {
                              md: 8,
                            },
                          }}
                        />
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="cortes"
                            label="Corte"
                            hasFeedback
                            rules={rules.required}
                          >
                            <Select
                              disabled={cortes.length === 1}
                              dataSource={cortes}
                              render={(e) => e?.apertura.format(DATE_FRONTEND_FORMAT)}
                            />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                    {hasAllViewPermission && (
                      <>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="unidad_de_recaudacion"
                            label="Unidad de recaudación"
                            hasFeedback
                            rules={rules.required}
                          >
                            <Select dataSource={unidadRecaudadora} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipos_de_depositos_bancarios"
                            label="Tipo de Depósito Bancario"
                            hasFeedback
                            rules={rules.required}
                          >
                            <Select dataSource={tipoDeDeposito} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="bancos"
                            label="Banco a depositar"
                            hasFeedback
                            rules={rules.required}
                          >
                            <Select
                              onChange={filter}
                              dataSource={banco}
                              labelProp="nombre"
                            />
                          </Form.Item>
                        </Col>
                      </>
                    )}

                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="cuenta_bancaria"
                        label="Cuenta Bancaria"
                        hasFeedback
                        rules={rules.required}
                      >
                        <Select
                          onChange={fillFields}
                          dataSource={cuentaBancaria}
                          labelProp="numero_de_cuenta"
                          allowClear
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="cuenta_contable_de_banco"
                        label="Cuenta Contable de Banco"
                        hasFeedback
                      >
                        <Input disabled allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="referencia_del_deposito"
                        label="Referencia Bancaria"
                        hasFeedback
                        rules={rules.referencia_bancaria}
                        normalize={capitalize}

                      >
                        <Input maxLength={24} allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <NumericInput
                        decimal
                        name="importe_del_deposito"
                        label="Importe"
                        required
                      />
                    </Col>
                    <Col xs={24} sm={24} md={16}>
                      <Form.Item
                        name="observaciones"
                        label="Observaciones"
                        hasFeedback
                      >
                        <Input.TextArea
                          autoSize={{ minRows: 3, maxRows: 5 }}
                          allowClear
                        />
                      </Form.Item>
                    </Col>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Row>
                </Form>
              </Col>
            </Card>
          </Col>
        )}
      </Spin>
      <BusquedaAvanzadaUsers
        visible={visibleBusqueda}
        setVisible={setVisibleBusqueda}
        callback={fetchUser}
        dataExterno={[]}
        setDataExterno={() => { }}
      />
      <BusquedaAvanzadaUsers
        visible={visibleAdvancedSupervisor}
        setVisible={setVisibleAdvancedSupervisor}
        callback={(selected) => {
          const _selected = {
            ...selected,
            nombre_completo: `${selected?.first_name} ${selected?.last_name
              || ''} ${selected?.second_last_name || ''}`,
          };
          setCajero([_selected]);
          form.setFieldsValue({
            usuario_cajero: selected.id,
          });
        }}
        dataExterno={[]}
        setDataExterno={() => { }}
      />
    </Row>
  );
};
export default DepositosBancarios;
